<template>
  <main class="main page-inside faq-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div class="title weight-600">{{ $t("FAQ") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section faq-section">
        <div class="wrapper">
          <div class="img-container">
            <img class="img" src="./../img/faqBg.webp" />
          </div>
          <div class="accordion">
            <div class="title">
              <b>{{ $t("Frequently Asked Questions") }}</b>
            </div>
            <div
              :class="['item', { active: isActivePanel(i) }]"
              v-for="(item, i) in $parent.faq"
              :key="i"
            >
              <div class="panel" @click="togglePanel(i)">
                <Transition>
                  <img
                    src="./../img/xmark.svg"
                    class="minus"
                    v-if="isActivePanel(i)"
                  />
                </Transition>
                <Transition>
                  <img
                    src="./../img/xmark2.svg"
                    class="plus"
                    v-if="!isActivePanel(i)"
                  />
                </Transition>
                <div class="panel-wrapper">
                  <div :class="['title small', { orange: isActivePanel(i) }]">
                    <b> {{ item.question }}</b>
                  </div>
                </div>
              </div>
              <div class="preview" v-if="isActivePanel(i)">
                <div class="desc">{{ item.answer }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Faq",
  props: [],
  components: {},
  data: function () {
    return {
      activePanels: [],
    };
  },
  mounted() {},
  methods: {
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
  },
};
</script>
